/**
 * Utility functions for FinFactor UI formatting and styling
 */

/**
 * Returns the color code for a financial trend based on the value and direction.
 * 
 * @param {string|number} value - The financial value (e.g., "₹100" or "-").
 * @param {boolean|null} isPositive - Whether the trend is positive (true), negative (false), or neutral/null.
 * @returns {string} HEX color string
 */
export const getTrendColor = (value, isPositive) => {
  if (
    value === "-" ||
    parseFloat(String(value || 0).replace(/[₹,]/g, "")) === 0 ||
    isPositive === null ||
    isPositive === undefined
  ) {
    return "white";
  }
  return isPositive ? "#10B981" : "#EF4444";
};

/**
 * Determines if a trend icon and percentage should be shown.
 * 
 * @param {string|number} value - The financial value
 * @param {boolean|null} isPositive - Whether the trend is positive 
 * @returns {boolean} True if the trend indicator is valid and should be shown
 */
export const hasTrend = (value, isPositive) => {
  return (
    value !== "-" &&
    parseFloat(String(value || 0).replace(/[₹,]/g, "")) !== 0 &&
    isPositive !== null &&
    isPositive !== undefined
  );
};
